import { PayablesService_payablesServiceGetQuery } from '@festina/moneyout-general-types/moneyout/hooks/PayablesService_payablesServiceGetQuery'

export const useFetchPayables =
  PayablesService_payablesServiceGetQuery.useSuspenseQuery
